import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Form from './Forms'
import { TextField, Button, Checkbox , Divider} from "@mui/material";
import Swal from 'sweetalert2'
import './style.css'
import AOS from "aos";
import "aos/dist/aos.css";
import Logo from "./logo-removebg-preview.png";

const BrokerLogin = () => {
    useEffect(() => {
        AOS.init({ once: true });
        window.scrollTo(0,0)
    } , [])
        
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [validate, setValidate] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    const validateLogin = () => {
        let isValid = true;

        let validator = Form.validator({
            email: {
                value: email,
                isRequired: true,
                isEmail: true
            },
            password: {
                value: password,
                isRequired: true,
                minLength: 8
            }
        });

        if (validator !== null) {
            setValidate({
                validate: validator.errors
            })

            isValid = false
        }
        return isValid;
    }

    const authenticate = (e) => {
        e.preventDefault();

        const validate = validateLogin();

        if (validate) {
            setValidate({});
            setEmail('');
            setPassword('');
            Swal.fire({
                position:'top-right',
                icon: 'success',
                title: 'Successfully Login',
                showConfirmButton: false,
                timer:3000
            })
        }
    }

    const togglePassword = (e) => {
        if (showPassword) {
            setShowPassword(false);
        } else {
            setShowPassword(true)
        }
    }

    return (
        // <div className="auth-wrapper-center">

        <div className="row g-0 auth-wrapper">
            <div className="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
                <div className="auth-background-holder"></div>
                <div className="auth-background-mask">
               
                <div 
                    data-aos="fade-right"
                    data-aos-duration="1000"
                    data-aos-easing="ease-in-out"
                    >
                    <h1>Welcome to </h1>
                    <h3>Rent by broker</h3>
                    </div>

                </div>
            </div>

            <div className="col-12 col-md-7 col-lg-6 auth-main-col text-center">
            <Link to="/" style={{textDecoration:"none"}}><img src={Logo} style={{height:65}}/></Link>
                <div className="d-flex flex-column align-content-end">
                    <div className="auth-body mx-auto">
                        <p>Broker Login</p>
                        <div className="auth-form-container text-start">
                            <form className="auth-form" method="POST" onSubmit={authenticate} autoComplete={'off'}>
                                <div className="email mb-3">

                                    
                                <TextField
                                        type="email"
                                        className={`form-control ${validate.validate && validate.validate.email ? 'is-invalid ' : ''}`}
                                         // id="email"
                                        name="email"
                                        value={email}
                                        // placeholder="Email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        id="outlined-basic"
                                        label="Email"
                                        variant="outlined"
                                        size="small"
                                    />

                                    <div className={`invalid-feedback text-start ${(validate.validate && validate.validate.email) ? 'd-block' : 'd-none'}`} >
                                        {(validate.validate && validate.validate.email) ? validate.validate.email[0] : ''}
                                    </div>
                                </div>

                                <div className="password mb-3">
                                    <div className="input-group">

                                    <TextField
                                         type={showPassword ? 'text' : 'password'}
                                         className={`form-control ${validate.validate && validate.validate.password ? 'is-invalid ' : ''}`}
                                         name="password"
                                         id="password"
                                         value={password}
                                        //  placeholder="Password"
                                         onChange={(e) => setPassword(e.target.value)}
                                        label="Password"
                                        variant="outlined"
                                        size="small"
                                    />
                                        <div className={`invalid-feedback text-start ${(validate.validate && validate.validate.password) ? 'd-block' : 'd-none'}`} >
                                            {(validate.validate && validate.validate.password) ? validate.validate.password[0] : ''}
                                        </div>
                                    </div>


                                    <div className="extra mt-3 row justify-content-between">
                                        <div className="col-6">
                                            <div className="form-check">
                                                <Checkbox size="small" style={{ float: 'none',marginRight: 5,marginBottom: 4 }} className="form-check-input" type="checkbox" id="remember" checked={remember} onChange={(e) => setRemember(e.currentTarget.checked)} />
                                                {/* <input className="form-check-input" type="checkbox" id="remember" checked={remember} onChange={(e) => setRemember(e.currentTarget.checked)} /> */}
                                                <label className="form-check-label" htmlFor="remember">
                                                    Remember me
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="forgot-password text-end">
                                                <Link to="/broker/forgot">Forgot password?</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <Button variant="contained" style={{ textTransform: 'none'}}  type="submit" className="btn btn-primary w-100 theme-btn mx-auto">Log In</Button>
                                    {/* <button type="submit" className="btn btn-primary w-100 theme-btn mx-auto">Log In</button> */}
                                </div>
                            </form>

                            <hr />
                            <div className="auth-option text-center pt-2">Don't have an account? <Link className="text-link" to="/broker/register" >Sign up </Link></div>
                      
                      
                      
                            <br />
                            <div className="auth-option text-center pt-2">
                                <a className="text-link  p-1" target="_blank" href="https://www.facebook.com" >
                               <img height="25" src={"https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_facebook-512.png"} />
                                </a>
                                
                                <a className="text-link p-2" target="_blank" href="https://www.twitter.com" >
                               <img height="25" src={"https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_twitter-256.png"} />
                                </a>

                                <a className="text-link p-1" target="_blank" href="https://www.instagram.com" >
                               <img height="25" src={"https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_instagram-512.png"} />
                            </a>
                          
                            </div>
                            <div className="auth-option text-center pt-2 text-link">Fllow Us</div>


                      
                        </div>
                    </div>
                </div>
            </div>

            </div>
        // </div>
            
    );
}

export default BrokerLogin;